module.exports = {"150784001":"拉布达林街道","150784002":"上库力街道","150784101":"黑山头镇","150784103":"莫尔道嘎镇","150784104":"恩和哈达镇","150784200":"三河回族乡","150784210":"恩和俄罗斯族民族乡","150784211":"蒙兀室韦苏木","150784212":"奇乾乡","150784400":"海拉尔农垦集团有限公司拉布大林农场分公司","150784401":"三河金騋农牧有限责任公司","150784402":"海拉尔农垦集团有限责任公司上库力农场分公司","150784403":"海拉尔农垦集团有限责任公司苏沁牧场分公司"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150784.json
// module id = 411
// module chunks = 0